<app-loading-spinner *ngIf="showSpinner"></app-loading-spinner>

<div *ngIf="!showSpinner && liberarResultado">
  <mat-card>
    <mat-card-title>Posição das equipes</mat-card-title>
    <mat-card-content>

      <mat-list>
        <mat-list-item *ngFor="let equipe of getResultado(), let i = index ">
          <p mat-list-icon>{{ i+1 }}</p>
          <p matLine><b>{{ equipe.nomeEquipe }}</b></p>
          <p matLine  class="demo-2"> Pontuação: {{ equipe.nota }} </p>
          <mat-divider></mat-divider>
        </mat-list-item>
      </mat-list>

    </mat-card-content>
  </mat-card>
</div>
